import { FC, memo } from 'react';

import { IconBase, IconBaseProps, matchSize } from './IconBase';

const IconChevronLeftSmall: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 25 25">
      <path
        d="M15.5 19L9.5 13L15.5 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

const IconChevronLeftMedium: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 65 65">
      <path
        d="M40.5 49.8333L24.5 33.8333L40.5 17.8333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

const IconChevronLeftBig: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 129 129">
      <path
        d="M80.5 99.1667L48.5 67.1667L80.5 35.1668"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

export const IconChevronLeft: FC<IconBaseProps> = memo(props => {
  const { size } = props;
  const Icon = matchSize(size, {
    s: IconChevronLeftSmall,
    l: IconChevronLeftBig,
    otherwise: IconChevronLeftMedium,
  });

  return <Icon {...props} />;
});
